<template>
  <v-list class="pa-0 mb-4" bg-color="transparent">
    <v-list-item
      border
      rounded="lg"
      :link="!forbidden"
      :aria-busy="loading ? 'true' : 'false'"
      :aria-disabled="forbidden ? 'true' : 'false'"
      @click="handleClick"
    >
      <template #prepend>
        <v-avatar color="primary" variant="tonal" size="36">
          <v-icon size="20">mdi-shield-account-outline</v-icon>
        </v-avatar>
      </template>
      <v-list-item-title>{{ $t("ncrm.contacts.dataProtection.header") }}</v-list-item-title>
      <v-list-item-subtitle>
        {{ subtitle }}
      </v-list-item-subtitle>
      <template #append>
        <div class="d-flex align-center ga-2">
          <v-progress-circular v-if="loading" indeterminate color="primary" size="22" width="2" />
          <!-- Lipsa dreptului nu este un defect: un lacăt discret, nu un
               triunghi de avertizare care trimite utilizatorul să raporteze
               o eroare inexistentă. -->
          <v-icon v-else-if="forbidden" size="20" class="text-medium-emphasis">mdi-lock-outline</v-icon>
          <v-chip
            v-else-if="!errorMessage"
            :color="status.color"
          >
            <v-icon start size="14">{{ status.icon }}</v-icon>
            {{ $t(status.labelKey) }}
          </v-chip>
          <v-icon v-else color="warning" size="20">mdi-alert-circle-outline</v-icon>
          <v-icon v-if="!forbidden" size="18" class="text-medium-emphasis">mdi-chevron-right</v-icon>
        </div>
      </template>
    </v-list-item>
  </v-list>
</template>

<script>
import axios from "axios";
import { resolvePrivacyStatus } from "@/Utile/ncrmPrivacyStatus.mjs";

export default {
  name: "NcrmPrivacyOverviewStatus",
  emits: ["activate"],
  props: {
    subjectType: {
      type: String,
      required: true,
      validator: (value) => ["person", "company"].includes(value),
    },
    subjectId: { type: [String, Number], required: true },
    active: { type: Boolean, default: true },
  },
  data: () => ({
    loading: false,
    errorMessage: "",
    forbidden: false,
    summary: null,
    requestSequence: 0,
  }),
  computed: {
    subjectKey() { return `${this.subjectType}:${this.subjectId}`; },
    status() { return resolvePrivacyStatus(this.summary?.summary_state); },
    subtitle() {
      const key = this.forbidden ? "noPermission" : null;
      if (key) return this.$t(`ncrm.contacts.dataProtection.record.${key}`);
      return this.errorMessage || this.$t("ncrm.contacts.dataProtection.record.summary");
    },
  },
  watch: {
    subjectKey: {
      immediate: true,
      handler() {
        this.invalidateRequest();
        this.summary = null;
        this.errorMessage = "";
        this.forbidden = false;
        if (this.active) this.fetchSummary();
      },
    },
    active(value, previous) {
      if (value && !previous) this.fetchSummary();
      if (!value) this.invalidateRequest();
    },
  },
  methods: {
    invalidateRequest() {
      this.requestSequence += 1;
      this.loading = false;
    },
    handleClick() {
      // Un rol fără acces la registru nu are ce deschide: tabul i-ar răspunde
      // tot cu lipsa permisiunii.
      if (this.forbidden) return;
      this.$emit("activate");
    },
    async fetchSummary() {
      const sequence = ++this.requestSequence;
      this.loading = true;
      this.errorMessage = "";
      this.forbidden = false;
      try {
        const { data } = await axios.get("/ncrm/privacy/summary", {
          params: { subject_type: this.subjectType, subject_id: this.subjectId },
        });
        if (sequence !== this.requestSequence) return;
        this.summary = data || null;
      } catch (error) {
        if (sequence !== this.requestSequence) return;
        // Aceeași distincție ca în tab: `403` înseamnă că rolul nu are acces la
        // registru, nu că încărcarea a eșuat.
        this.forbidden = Number(error?.response?.status) === 403;
        this.errorMessage = this.forbidden
          ? ""
          : this.$t("ncrm.contacts.dataProtection.record.loadError");
      } finally {
        if (sequence === this.requestSequence) this.loading = false;
      }
    },
  },
};
</script>
